( function( window, document, $ ) {
    'use strict';

    $( document ).ready( function() {
        // --------------------------------------------------
        // DECLARE VARS
        // --------------------------------------------------
        var filtersElem;
        var filterItemElems;
        var filterItemCheckboxElems;
        var resourceBlockElems;

        function findElements() {
            filtersElem = $( '.js--filters' );
            filterItemElems = $( '.js--filter-item' );
            filterItemCheckboxElems = $( '.js--filter-item-checkbox' );
            resourceBlockElems = $( '.js--resource-block' );
        }

        // --------------------------------------------------
        // DEFINE FUNCTIONS
        // --------------------------------------------------
        function applyFilters() {
            if ( resourceBlockElems && filterItemElems ) {
                var selectedFilters = filterItemElems
                    .map( function( i, elem ) {
                        var checkboxElem = $( elem ).find( 'input[type="checkbox"]' );

                        return $( checkboxElem ).is( ':checked' ) ? elem.dataset.resourceType : null;
                    } )
                    .filter( function( i, resourceType ) {
                        return !!resourceType;
                    } )
                    .toArray();

                // If the `selectedFilters` array is empty, show all 'resource block' elems.
                // Otherwise, selectively show/hide individual elems.
                if ( !selectedFilters.length ) {
                    resourceBlockElems.removeClass( 'is-hidden' );
                } else {
                    resourceBlockElems.each( function( i, elem ) {
                        elem = $( elem );

                        var resourceType = elem.attr( 'data-resource-type' );

                        if ( selectedFilters.indexOf( resourceType ) === -1 ) {
                            elem.addClass( 'is-hidden' );
                        } else {
                            elem.removeClass( 'is-hidden' );
                        }
                    } );
                }
            }
        }

        function init() {
            // Get/refresh elem. refs.
            findElements();

            // Show filters div.
            filtersElem.show();

            // EVENTS
            filterItemCheckboxElems.on( 'click', applyFilters );

            filterItemCheckboxElems.on( 'keypress', function( e ) {
                // If user hit the ENTER key:
                // - Toggle check state on current elem.
                // - Apply filters.
                if ( e && e.keyCode && e.keyCode === 13 ) {
                    this.checked = !this.checked;
                    applyFilters();
                }
            } );
        }

        // --------------------------------------------------
        // INIT
        // --------------------------------------------------
        init();

        if ( typeof Barba !== 'undefined' && typeof Barba.Dispatcher === 'object' ) {
            Barba.Dispatcher.on( 'newPageReady', function() {
                init();
            } );
        }

    } );
} )( window, document, jQuery );
